import { computed, ref, watch } from 'vue';

//COMPONENTS
import PinCreate from '../PinCreate/index.vue';
import PinRestore from '../PinRestore/index.vue';
import PinValidate from '../PinValidate/index.vue';
import PinRestoreCode from '../PinRestoreCode/index.vue';

// COMPOSABLES
import { useZIndex } from '@flash-global66/g-hooks';
import { usePinFlow } from '../../composables/usePinFlow';

// TYPES
import type { PinEmits, UsePinReturn } from '../../types/pin.type';

const components = {
  PinCreate,
  PinValidate,
  PinRestore,
  PinRestoreCode,
};

export function usePin(
  emits: PinEmits,
  getCurrentPath: () => string | undefined
): UsePinReturn {
  const pinFlow = usePinFlow();

  const { nextZIndex } = useZIndex();

  const zIndex = ref(nextZIndex());

  const currentComponent = computed(() => components[pinFlow.type.value]);

  function onClose() {
    emits('close');
  }

  watch(
    () => pinFlow.show.value,
    (newValue) => {
      if (newValue) zIndex.value = nextZIndex();
    }
  );

  watch(getCurrentPath, onClose);

  return {
    pinFlow,
    zIndex,
    currentComponent,
    onClose,
  };
}
